import { StartupQueryParameterKeys } from '../constants/App';
import { ApplicationStateKeys } from '../constants/ApplicationStateKeys';

export function get(state, key) {
  return (
    state.application &&
    state.application.getIn([ApplicationStateKeys.STARTUP_QUERY_PARAMETERS, key])
  );
}

export function getFamilyPlanInviteToken(state) {
  return get(state, StartupQueryParameterKeys.FAMILY_PLAN_INVITE_TOKEN);
}

export function getAmpSSO(state) {
  return get(state, StartupQueryParameterKeys.AMP_SSO);
}

export function getERequestId(state) {
  return get(state, StartupQueryParameterKeys.E_REQUEST_ID);
}

export function getStore(state) {
  return get(state, StartupQueryParameterKeys.STORE);
}

export function getFeatureCode(state) {
  return get(state, StartupQueryParameterKeys.FEATURE_CODE);
}

export function getEntitlementId(state) {
  return get(state, StartupQueryParameterKeys.ENTITLEMENT_ID);
}

export function getRegister(state) {
  return get(state, StartupQueryParameterKeys.REGISTER);
}

export function getInteractiveRadioStartupModeId(state) {
  return parseInt(get(state, StartupQueryParameterKeys.MODE_ID), 10);
}

export function getToken(state) {
  return get(state, StartupQueryParameterKeys.TOKEN);
}

export function getAccessToken(state) {
  return get(state, StartupQueryParameterKeys.ACCESS_TOKEN);
}

// @todo GRNWEB-4689
export function getGreenfieldUpgradeFlag(state) {
  return get(state, StartupQueryParameterKeys.GREENFIELD_UPGRADE_FLAG);
}
